import React from 'react';
import Match from './Match';
import {MatchInterface} from './matchInterface';

interface MatchSectionProps {
    matches: MatchInterface[]
}

const MatchSection = ({matches = []}: MatchSectionProps): React.ReactNode => <div className="match-section">
    <Match match={matches[0]} />
    <Match match={matches[1]} />
</div>;

export default MatchSection;
